import { motionValue } from "framer-motion";

// Shared scroll MotionValues fed directly by Lenis's scroll callback (synchronously, same frame
// the scroll is applied). Scroll-linked parallax reads these instead of framer-motion's useScroll,
// which samples in the frame "read" phase and races Lenis's "update" write — the cause of jitter.
export const scrollYMV = motionValue(0); // absolute scroll position in px
export const scrollProgressMV = motionValue(0); // 0..1 of total scrollable height
